import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { PrimaryButton } from '../index';

export const LoginButton = () => {
  const { loginWithRedirect } = useAuth0();
  return <PrimaryButton title={'Login'} onPress={() => loginWithRedirect()} />;
};
